module.exports = __webpack_public_path__ + "static/media/mem10.17aee188.jpg";